exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._153OD5ID4shbCZAd342Zxp{position:relative;display:inline-block}._1FkLCGwowRcN2JCk3oJ6Xb{color:#fa6400;background:#fff;border-radius:50%;border:solid 2.5px #fa6400;position:absolute;bottom:-12%;right:-12%}\n", ""]);

// Exports
exports.locals = {
	"container": "_153OD5ID4shbCZAd342Zxp",
	"flair": "_1FkLCGwowRcN2JCk3oJ6Xb"
};